import { useMutation } from "@apollo/client";

import { GqlProjectUserInviteInput, gql } from "~/__generated__";

const PROJECT_USER_INVITE = gql(`
    mutation ProjectUserInvite($input: GqlProjectUserInviteInput!) {
        projectUserInvite(input: $input) {
            id
        }
    }
`);

export default function useProjectUserInvite() {
    const [mutate, { loading, error, data }] = useMutation(PROJECT_USER_INVITE, {
        errorPolicy: "all",
    });

    const inviteProjectUser = (projectId: string, data: Omit<GqlProjectUserInviteInput, "projectId">) =>
        mutate({ variables: { input: { ...data, projectId } } });

    return {
        inviteProjectUser,
        loading,
        error,
        data: data?.projectUserInvite,
    };
}
